import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class TaskDelay extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "task-delay";
    static pluralName = "task-delays";
    static displayName = "TaskDelay";

    constructor() {
        super(`${TaskDelay.kind}`, `${TaskDelay.singularName}`, `${TaskDelay.pluralName}`);
    }

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true,
        });
        return await this.fetch(_query);
    }

    async getById(id, query = {}) {
        return await this.find(id, { populate: "*", ...query });
    }

    async getTaskDelays(taskId, query = {}) {
        const qs = require('qs');
        const _query = qs.stringify(query, {encodeValuesOnly: true});
        return await this.action(_query, `/tasks/${taskId}/delays`);
    }

    async delay(taskId, data = {}) {
        return await this.postAction(`/tasks/${taskId}/delay`, data);
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data) {
        return await this.update(id, data);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }
}
